var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3671 21.5465V11.3821M10.3671 11.3821L1.51446 6.29989M10.3671 11.3821L19.2198 6.29989M5.79339 3.52453L14.9408 8.7592M9.35073 21.272C9.65975 21.4504 10.0103 21.5443 10.3671 21.5443C10.7239 21.5443 11.0745 21.4504 11.3835 21.272L18.4982 17.2062C18.8069 17.028 19.0633 16.7717 19.2417 16.463C19.4201 16.1544 19.5142 15.8043 19.5146 15.4478V7.31623C19.5142 6.95974 19.4201 6.60961 19.2417 6.30097C19.0633 5.99233 18.8069 5.73603 18.4982 5.55778L11.3835 1.49202C11.0745 1.3136 10.7239 1.21967 10.3671 1.21967C10.0103 1.21967 9.65975 1.3136 9.35073 1.49202L2.23605 5.55778C1.92733 5.73603 1.67092 5.99233 1.49253 6.30097C1.31413 6.60961 1.22003 6.95974 1.21967 7.31623V15.4478C1.22003 15.8043 1.31413 16.1544 1.49253 16.463C1.67092 16.7717 1.92733 17.028 2.23605 17.2062L9.35073 21.272Z",
    stroke: "#8B5CF6",
    strokeWidth: 2.43932,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.2c94fbca433fce1e3f078ffb1ee167a1.svg";
export { ForwardRef as ReactComponent };